import { useState, useEffect } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

export default function Cart({ setCartCount }) {

  const [cartItems, setCartItems] = useState([])

  const navigate = useNavigate();

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    try {
      const response = await API.get("/api/cart")
      setCartItems(response.data.sort((a, b) => a.cartId - b.cartId))
    } catch (error) {
      console.log(error)
    }
  }

  const totalAmount = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const deliveryCharge = totalAmount > 500 ? 0 : 40;
  const finalAmount = totalAmount + deliveryCharge;

  //Handle Increase
  const handleIncrease = async (item) => {
    try {
      await API.put(`/api/cart/update/${item.cartId}?quantity=${item.quantity + 1}`);

      setCartItems(prev => {
        const updated = prev.map(i =>
          i.cartId === item.cartId
            ? { ...i, quantity: i.quantity + 1 }
            : i
        );
        setCartCount(updated.length);
        return updated;
      });
    } catch (error) {
      console.log(error)
    }
  };

  //Handle Decrease
  const handleDecrease = async (item) => {
    try {
      await API.put(`/api/cart/update/${item.cartId}?quantity=${item.quantity - 1}`);
      setCartItems(prev => {
        const updated = prev
          .map(i =>
            i.cartId === item.cartId
              ? { ...i, quantity: i.quantity - 1 }
              : i
          )
          .filter(i => i.quantity > 0);
        setCartCount(updated.length);
        return updated;
      });
    } catch (error) {
      console.log(error)
    }
  };

  //Handle Remove
  const handleRemove = async (item) => {
    try {
      setCartItems(prev => {
        const updated = prev.filter(i => i.cartId !== item.cartId);
        setCartCount(updated.length);
        return updated;
      });
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div style={{ marginTop: "30px", background: "#f1f3f6", minHeight: "100vh" }}>
      <div className="page-container py-4">
        <div className="row">

          <div className="col-md-8">

            {cartItems.length === 0 ? (
              <div className="card p-4 text-center">
                <h5>Your Cart is Empty</h5>
              </div>
            ) : (
              cartItems.map((item) => (
                <div key={item.cartId} className="card mb-3 p-3 shadow-sm">
                  <div className="row align-items-center">

                    <div className="col-md-3 text-center">
                      <img
                        src={item.imageUrl}
                        alt={item.productName}
                        className="img-fluid"
                        style={{ height: "120px", objectFit: "cover" }}
                      />
                    </div>

                    <div className="col-md-6">
                      <h6>{item.productName}</h6>
                      <p className="text-muted small">
                        {item.product?.categories?.name}
                      </p>

                      <h5 className="fw-bold">
                        ₹{item.price?.toFixed(2)}
                      </h5>

                      <p className="text-success small">
                        Delivery in 2 days
                      </p>
                    </div>

                    <div className="col-md-3 text-center">
                      <div className="d-flex flex-column align-items-center">
                        <div className="d-flex align-items-center mb-2">

                          <button className="btn btn-outline-secondary btn-sm"
                            onClick={() => handleDecrease(item)}
                          >
                            -
                          </button>

                          <span className="mx-2 fw-bold">
                            {item.quantity}
                          </span>

                          <button className="btn btn-outline-secondary btn-sm"
                            onClick={() => handleIncrease(item)}
                          >
                            +
                          </button>

                        </div>
                        <button className="btn btn-outline-secondary btn-sm"
                          onClick={() => handleRemove(item)}
                        >
                          Remove
                        </button>

                      </div>
                    </div>

                  </div>
                </div>
              ))
            )}

          </div>

          <div className="col-md-4">
            <div className="card p-3 shadow-sm">

              <h6 className="text-muted border-bottom pb-2">
                PRICE DETAILS
              </h6>

              <div className="d-flex justify-content-between mt-3">
                <span>Price ({cartItems.length} items)</span>
                <span>₹{totalAmount.toFixed(2)}</span>
              </div>

              <div className="d-flex justify-content-between">
                <span>Delivery Charges</span>
                {deliveryCharge === 0 ? (
                  <span className="text-success">FREE</span>
                ) : (
                  <span>₹{deliveryCharge}</span>
                )}
              </div>

              <hr />

              <div className="d-flex justify-content-between fw-bold">
                <span>Total Amount</span>
                <span>₹{finalAmount.toFixed(2)}</span>
              </div>

              {deliveryCharge === 0 && totalAmount > 0 && (
                <p className="text-success small mt-2">
                  You saved ₹40 on delivery
                </p>
              )}

              <button
                className="btn btn-warning w-100 mt-3"
                disabled={cartItems.length === 0}
                onClick={() => navigate("/checkout")}
              >
                PLACE ORDER
              </button>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}